// extracted by mini-css-extract-plugin
module.exports = {"HeroWrapper":"Hero_HeroWrapper__IviKy","InfoOffer":"Hero_InfoOffer__1yttT","Caption":"Hero_Caption__3sBQc","Description":"Hero_Description__2bA8u"};